import Navbar from '../../components/layout/Navbar';
import GraficosScuba3s from '../../components/sections/GraficosScuba3s';
import NotificacionesEmail from '../../components/sections/NotificacionesEmail';
import Footer from '../../components/layout/Footer';

export default function Scuba3sPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="scuba3s" />

      <main className="pt-16">
        {/* Sección Scuba3s */}
        <section id="scuba3s" className="py-20 bg-gradient-to-br from-cyan-50 to-teal-50 min-h-screen">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-slate-800 mb-4">Dispositivo Scuba3s</h2>
              <p className="text-xl text-slate-600">Mediciones avanzadas y gráficos en tiempo real</p>
            </div>
            <div className="space-y-8">
              <GraficosScuba3s />
              <NotificacionesEmail />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}